import { MeModel } from '@/entities/accounts/me-model.interface';
import * as types from '@/store/types';
import accountsApi from '@/api/accounts.api';

const TOKEN_KEY = 'token';
const ME_KEY = 'me';

export default {
    hasToken(): boolean {
        return !!localStorage.getItem(TOKEN_KEY);
    },
    storeToken(token: string) {
        localStorage.setItem(TOKEN_KEY, token);
    },
    storeMe(meModel: MeModel) {
        localStorage.setItem(ME_KEY, JSON.stringify(meModel));
    },
    clear() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(ME_KEY);
    },

    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    },

    getMe(): MeModel {
        const t = localStorage.getItem(ME_KEY);
        if (!t) {
            return null;
        }
        return JSON.parse(t);
    },

    processLoginSuccess(store, token) {
        store.dispatch(types.AUHT_LOGIN, token);
        store.dispatch(types.ALERT_LOAD_LOGIN_ALERT);
    }
};
